// ark-migration-status=migrated
import { createViewConfig } from '@sail/ui';
export const FormBlockConfig = createViewConfig({
    props: {},
    name: 'FormBlock',
    defaults: {
        gap: 'xlarge'
    }
});
export default FormBlockConfig;

//# sourceMappingURL=FormBlockConfig.js.map